<template>
  <div class="main-wrapper">
    <div class="blackTransBg">
      <img src="./assets/logo.png" alt="Logo" class="logo">
      <h1 class="brandingText">
        Taj <span style="color: white; text-transform: capitalize">Dhaba</span>
      </h1>
      <h4
        style="
          color: white;
          text-align: center;
          margin-top: 0;
          border-bottom: 2px solid #d8a200;
          padding-bottom: 0.6rem;
        "
      >
        The Taste of Gulbarga
      </h4>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html {
  font-family: sans-serif;
  -webkit-tap-highlight-color: transparent;
}


.logo{
  height: 7rem;
  width: auto;
}
.blackTransBg {
  border-radius: 20px;
  box-shadow: 0px 10px 100px 22px rgba(0, 0, 0, 0.1);

  display: grid;
  place-items: center;
  background-color: rgba(0, 0, 0, 0.731);
  backdrop-filter: blur(4px);
  margin-bottom: 1rem;
}
.brandingText {
  color: #d8a200;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 2.6rem;

  padding-bottom: 8px;
  margin: 0;
}
.card-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.2rem;
}
.main-wrapper {
  margin: 0 1rem;
}
.menuList {
  display: grid;
  grid-template-columns: 4fr repeat(3, 1fr);
  border-bottom: 1px solid black;
}
.menuList > span {
  margin-bottom: 0.6rem;
  padding: 0.4rem;
}
/* .menuList-header {
  border-bottom: 2px solid #f8c892;
} */

ul {
  padding: 0;
}

a {
  text-decoration: none;
  color: #000000d6;
}
/* mealHeading => starters, main course etc */
.mealHeading {
  text-align: center;
  color: white;
}
.detailHeading {
  /* color: #d07003; */
  /* color: #; */
  margin-top: 0;
  font-size: 2rem;
}
</style>
